import {
  Component,
  Directive,
  HostListener,
  Optional,
  Input,
  Output,
  EventEmitter
} from "@angular/core";

import { DrawerRef, Drawer } from "../../../drawer.service";

@Component({
  selector: "uex-drawer-close",
  templateUrl: "./close.component.html"
})
export class DrawerCloseComponent {
  @Input() public autoclose = true;
  @Output() public color = "dark";
  @Output("click") private _onClick: EventEmitter<void> = new EventEmitter();

  constructor(@Optional() private _drawerRef: DrawerRef) {
    this._drawer = this._drawerRef.drawer;
  }

  private _drawer: Drawer;

  /**
   * @internal
   */
  public onClick(event: MouseEvent) {
    if (this._drawer && this.autoclose) {
      this._drawer.close();
    }
    this._onClick.emit();
  }
}

@Directive({
  selector: "[drawerClose], [drawer-close]"
})
export class DrawerCloseDirective {
  constructor(@Optional() private _drawerRef: DrawerRef) {
    this._drawer = this._drawerRef.drawer;
  }

  private _drawer: Drawer;

  @HostListener("click") public _onClick() {
    if (this._drawer) {
      this._drawer.close();
    }
  }
}
